/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../utils/Functions';
import { const_var, params } from '../../../../../redux/reducers/reducer';
import ShutterModel from './ShutterModel';
import LatticeModel from './LatticeModel';


const WindowWithoutShuttersFourGridWindow  = ({ width, height, trimWidth, glassTexture }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])
    
    const windowWidth = width - trimWidth * 4
    const windowHeight = (height - trimWidth * 4) / 2
    const railThickness = trimWidth / 2
    const railWidth = width - trimWidth * 2;
    const railHeight = height - trimWidth * 2;
    const distanceY = (railHeight - railThickness * 4) / 4;
    const patternWidth = (width - trimWidth * 5 - (trimWidth / 4 * 3) * 2) / 2;
    const patternHeight = (height / 2 - trimWidth * 2 - (trimWidth / 4 * 3) * 2 - trimWidth / 2) / 2 - 0.022


    const outTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2, height / 2);
        model.lineTo(width / 2, height / 2);
        model.lineTo(width / 2, -height / 2);
        model.lineTo(-width / 2, -height / 2);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        hole.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])

    const insideTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        model.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + (trimWidth * 2), height / 2 - (trimWidth * 2));
        hole.lineTo(width / 2 - (trimWidth * 2), height / 2 - (trimWidth * 2));
        hole.lineTo(width / 2 - (trimWidth * 2), -height / 2 + (trimWidth * 2));
        hole.lineTo(-width / 2 + (trimWidth * 2), -height / 2 + (trimWidth * 2));
        hole.closePath();
        
        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])
    
    const windowTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, -windowHeight / 2);
        model.lineTo(-windowWidth / 2, -windowHeight / 2);
        model.closePath();
        
        const hole = new THREE.Path();
        hole.moveTo(-(windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        hole.lineTo((windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        hole.lineTo((windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        hole.lineTo(-(windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        hole.closePath();

        model.holes.push(hole);

        return model;
    
    }, [width, height, trimWidth])

    const railModel = useMemo(() => {
        let model = [];

        const railThickness = trimWidth / 5 * 4
        const railWidth = width - trimWidth * 6;
        const railHeight = height - trimWidth * 6;
        const distanceX = (- railThickness * 2) / 6;
        const distanceY = (railHeight - railThickness * 4) / 4;

        const horizontalUpperModel = new THREE.Shape();
        horizontalUpperModel.moveTo(-railWidth / 2, railThickness * 1 + distanceY * 1);
        horizontalUpperModel.lineTo(-railWidth / 2, railThickness * 2 + distanceY * 1);
        horizontalUpperModel.lineTo(railWidth / 2, railThickness * 2 + distanceY * 1);
        horizontalUpperModel.lineTo(railWidth / 2, railThickness * 1 + distanceY * 1);
        horizontalUpperModel.closePath();

        const verticalModel = new THREE.Shape();
        verticalModel.moveTo((distanceX + railThickness), trimWidth);
        verticalModel.lineTo((distanceX + railThickness), railHeight / 2);
        verticalModel.lineTo((distanceX), railHeight / 2);
        verticalModel.lineTo((distanceX), trimWidth);

        model.push(horizontalUpperModel);
        
        model.push(verticalModel);

        return model;
    }, [width, height, trimWidth])

    const underPatternTrimModel = useMemo(() => {
        let model = []

        const trim = new THREE.Shape();
        trim.moveTo(-railWidth / 2, -height / 2 + trimWidth);
        trim.lineTo(-railWidth / 2, -trimWidth / 2);
        trim.lineTo(railWidth / 2, -trimWidth / 2);
        trim.lineTo(railWidth / 2, -height / 2 + trimWidth);
        trim.closePath();

        const trimHole = new THREE.Path();
        trimHole.moveTo(-(railWidth / 2 - trimWidth / 2), -height / 2 + trimWidth + trimWidth / 2);
        trimHole.lineTo(-(railWidth / 2 - trimWidth / 2), -trimWidth / 2 - trimWidth / 2);
        trimHole.lineTo((railWidth / 2 - trimWidth / 2), -trimWidth / 2 - trimWidth / 2);
        trimHole.lineTo((railWidth / 2 - trimWidth / 2), -height / 2 + trimWidth + trimWidth / 2);
        trimHole.closePath();

        trim.holes.push(trimHole);

        const railHorizontal = new THREE.Shape();
        railHorizontal.moveTo(-railWidth / 2, -railHeight / 4 - trimWidth / 4 - (trimWidth / 2 + trimWidth / 4));
        railHorizontal.lineTo(-railWidth / 2, -railHeight / 4 - trimWidth / 4 + (trimWidth / 2 + trimWidth / 4));
        railHorizontal.lineTo(railWidth / 2, -railHeight / 4 - trimWidth / 4 + (trimWidth / 2 + trimWidth / 4));
        railHorizontal.lineTo(railWidth / 2, -railHeight / 4 - trimWidth / 4 - (trimWidth / 2 + trimWidth / 4));
        railHorizontal.closePath();

        const railVertical = new THREE.Shape();
        railVertical.moveTo(-(trimWidth / 2 + trimWidth / 4), -height / 2 + trimWidth)
        railVertical.lineTo(-(trimWidth / 2 + trimWidth / 4), -trimWidth / 2)
        railVertical.lineTo((trimWidth / 2 + trimWidth / 4), -trimWidth / 2)
        railVertical.lineTo((trimWidth / 2 + trimWidth / 4), -height / 2 + trimWidth)
        railVertical.closePath();

        model.push(trim);
        model.push(railHorizontal);
        model.push(railVertical);

        return model;

    
    }, [width, height, trimWidth])



    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        model.lineTo((windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        model.lineTo((windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        model.lineTo(-(windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        model.closePath();

        return model
    
    }, [width, height, trimWidth])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[outTrimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='inside-trim'>
                <extrudeGeometry args={[insideTrimModel, extrudeSettings(0.4)]} />
                <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.2} />
            </mesh>

            {/* <mesh name='pattern-trim' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[underPatternTrimModel, extrudeSettings(0.2)]} />
                    <meshStandardMaterial color={'#FFFFFF'} side={THREE.DoubleSide} metalness={0.5} />
            </mesh> */}

            {new Array(2).fill("").map((_, index) =>
                <group key={`window-model-${index}`} name='window-model' position={[0, Math.pow(-1, index) * (-windowHeight / 2), 0.1 + 0.1 * index]}>
                    <mesh name='pattern-trim'>
                        <extrudeGeometry args={[windowTrimModel, extrudeSettings(0.1)]} />
                        <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.3}  />
                    </mesh>
                </group>
            )}  
            <mesh name='glass' position={[0, windowHeight / 2, 0.21]}>
                <extrudeGeometry args={[glassModel, extrudeSettings(0.08)]} />
                <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
            </mesh>

            {new Array(2).fill("").map((_, index) =>
                <group key={`rail-model-${index}`} name='rail-model' position={[0, windowHeight * (index - 1), 0.1 + 0.1 * index]}>
                    <mesh name='pattern-rail'>
                        <extrudeGeometry args={[railModel, extrudeSettings(0.1)]} />
                        <meshStandardMaterial  color={'#ffffff'} side={THREE.DoubleSide} roughness={0.3} metalness={0.2} />
                    </mesh>
                </group>
            )}

            {new Array(2).fill("").map((_, index) =>
                <group key={`shutter-model-${index}`} position={[Math.pow(-1, index) * (width / 2 + width / 4), 0, 0.25]}>
                    <ShutterModel width={width / 2} height={height} />
                </group>
            )}

            {new Array(2).fill("").map((_, index) =>
                <group name='lattice-model'  position={[Math.pow(-1, index) * (patternWidth / 2 + trimWidth / 3) + 0.01 , 0, 0.045]}>
                    <group name='upper-lattice' position={[0, -trimWidth, 0]}>
                        <LatticeModel width={patternWidth} height={patternHeight} />
                    </group>
                    <group name='under-lattice' position={[0, -trimWidth - patternHeight - 0.06, 0]}>
                        <LatticeModel width={patternWidth} height={patternHeight} />
                    </group>
                </group>
            )}

        </>
    )
}

export default WindowWithoutShuttersFourGridWindow 